import React from 'react'

const HeadsMessage = () => {

    const content = new getContent();

    return (
        <section className='p-4 md:p-24'>

            <h1 className='font-light mt-20 mb-8 text-3xl'>{content.heading}</h1>


            <h2 className="font-bold mb-2 text-2xl">{content.subHeading}</h2>


            <p>{content.content}</p>

        </section>
    )
}

export default HeadsMessage



class getContent {


    heading = `Head’s Message`


    subHeading = `Dear Parent or Guardian,`



    content = `Some prospective patrons, like you, have passed judgement on our learning environment based on our temporary rented premises. Those of you who looked beyond the premises marvel at our learning environment. These parents primarily selected us as we are the first school in Pakistan to offer the educational programmes of the International Baccalaureate Organisation (IBO). Amongst these parents there are a few who prior to admitting their child already knew about the internationally acclaimed education programmes of IBO and the remaining disregarded the traditional education systems like the prevalent British GCE O-Levels and the national matriculation offered in other schools for IB education which is clearly better suited for the 21st Century.   
 
The vision of The International School (TIS) Board members may have placed the school in an exclusive group of the IB World Schools but it also challenged its leadership and management in convincing local parents to change from the status quo of examination based education to a ‘revolutionary’ education programme for life based on the concepts of skill, inquiry based learning and criterion based assessment. We, at TIS, know teachers are the true agents of change and guardians of learning. This and the standards of scrutiny by IBO have produced a vibrant teacher development programme. The success of the programme and the high retention rates of teachers have enabled most of the teaching staffs to become IB examiners.

Our graduates with the award of the high school IB Diploma or a selection of IB Certificate courses have all been offered admissions to Colleges and Universities in the UK, USA, Canada, Australia and Pakistan. In Pakistan, IB diploma holders are awarded equivalency by the concerned authorities, I.B.C.C., as dictated by a resolution passed in 1985.

The uniqueness of our learning environment is the IB. This makes us blend the rigour of academics with the concepts of internationalism, cultural understanding, inter-disciplinary teaching, inquiry based learning, community service, environment, health & social education, creativity and physical education.

We would encourage you to learn more about our day co-educational private learning environment.

Taymur Mirza
Head of School`


}